import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';

import { searchUsersByFilterAsync, getFcmTokenByUserIdAsync } from './slices';

export const searchUsersByFilter = async (
  searchFilter: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(searchUsersByFilterAsync(searchFilter));

  return handleDispatchResult(res, onSuccess);
};

export const getFcmTokenByUserId = async (
  userId: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getFcmTokenByUserIdAsync(userId));

  return handleDispatchResult(res, onSuccess);
};
